import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { LoggerEcl } from '@app/core/enums/logger-ecl.enum';

@Component({
  selector: 'gc-ld-logger-noise-ecl-indicator',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ld-logger-noise-ecl-indicator.component.html',
  host: {
    class: 'flex items-center justify-center',
  },
})
export class LdLoggerNoiseEclIndicatorComponent {
  public ecl = input.required<LoggerEcl | undefined>();

  protected readonly defaultColor = 'var(--p-other-opacity-gray-100-50)';

  public eclState = computed(() => {
    const value = this.ecl();

    if (value === LoggerEcl.Value2) {
      return { color: 'var(--p-other-red-500)', bgColor: 'var(--p-red-50)', level: 3 };
    }
    if (value === LoggerEcl.Value1) {
      return { color: 'var(--p-orange-500)', bgColor: 'var(--p-orange-100)', level: 2 };
    }
    if (value === LoggerEcl.Value0) {
      return { color: 'var(--p-other-green-500)', bgColor: 'var(--p-green-100)', level: 1 };
    }

    return { color: this.defaultColor, bgColor: 'transparent', level: 0 };
  });
}
